import { Home, ArrowLeft, Search, HelpCircle } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 flex items-center justify-center px-4">
      <div className="max-w-lg w-full text-center">
        {/* 404 Number */}
        <div className="relative mb-8">
          <h1 className="text-[150px] md:text-[200px] font-black text-white/10 leading-none select-none">
            404
          </h1>
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-24 h-24 bg-gradient-to-br from-amber-500 to-orange-600 rounded-full flex items-center justify-center animate-bounce">
              <Search className="w-12 h-12 text-white" />
            </div>
          </div>
        </div>

        {/* Message */}
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">
          Sayfa Bulunamadı
        </h2>
        <p className="text-white/70 mb-8 text-lg">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
          <br />
          <span className="text-sm">Sidan kunde inte hittas.</span>
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
          <a
            href="/"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-amber-500 to-orange-600 text-white font-bold rounded-xl hover:shadow-lg hover:scale-105 transition-all"
          >
            <Home className="w-5 h-5" />
            Ana Sayfa
          </a>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white/10 border border-white/20 text-white font-semibold rounded-xl hover:bg-white/20 transition-all"
          >
            <ArrowLeft className="w-5 h-5" />
            Geri Dön
          </button>
        </div>

        {/* Helpful Links */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 p-6">
          <h3 className="text-white font-semibold mb-4 flex items-center justify-center gap-2">
            <HelpCircle className="w-5 h-5 text-amber-400" />
            Faydalı Linkler
          </h3>
          <div className="grid grid-cols-2 gap-3 text-sm">
            <a href="/" className="text-white/70 hover:text-amber-400 transition-colors">
              🏠 Ana Sayfa
            </a>
            <a href="/sss" className="text-white/70 hover:text-amber-400 transition-colors">
              ❓ Sık Sorulan Sorular
            </a>
            <a href="/blog" className="text-white/70 hover:text-amber-400 transition-colors">
              📝 Blog
            </a>
            <a href="/login" className="text-white/70 hover:text-amber-400 transition-colors">
              🔐 Giriş Yap
            </a>
          </div>
        </div>

        {/* SEO Text */}
        <p className="mt-8 text-white/40 text-xs">
          İsveç ehliyet sınavı hazırlık platformu - Ehliyet.nu
        </p>
      </div>
    </div>
  );
}
